export const CLEVERTAP_KEYS = {
    CART_VIEWED_EVENT: "Food Cart Viewed",
    GIFTING_CART_VIEWED_EVENT: "Gifting Cart Viewed",
    CART_COUPON_APPLIED_EVENT: "Food Coupon Applied",
    RESTAURANT_NAME: "Restaurant Name",
    RESTAURANT_ID: "Restaurant ID",
    RESTAURANT_AREA: "Restaurant Area",
    ITEM_TOTAL: "Item Total",
    TAXES_AND_CHARGES: "Taxes and Charges",
    SURGE_FEE: "Surge Fee",
    DEL_FEE: "Del Fee",
    TOTAL_DISCOUNT: "Total Discount",
    TOTAL_BILL_VALUE: "Total Bill Value",
    COUPON_USED: "Coupon Used",
    COUPON_APPLIED_FLAG: "Coupon Applied Flag",
    COUPON_NAME: "Coupon Name",
    IS_SWIGGY_ONE: "Is Swiggy One",
    ADDRESS_TYPE: "Address Type",
    MEAL_TYPE: "Meal Type",
    QUANTITY: "Quantity",
    CART_ID: "Cart ID",
    ADDRESS_ID: "Address ID",
    SUPER_PLAN_TYPE: "Super Plan Type",
    SWUID: "SWUID",
    STATUS: "Status",
    MESSAGE: "Message",
    COUPON_CODE: "Coupon Code",
    SAVINGS_AMOUNT: "Savings Amount",
    ONE_PLAN_ADDED: "One Plan Added",
    ONE_PLAN_DURATION_ADDED: "One Plan Duration Added",
    EO_UNLOCKED: "EO Unlocked",
    EO_DISCOUNT_PERCENTAGE: "EO Discount Percentage",
    EO_DISCOUNT_SAVINGS: "EO Discount Savings",
    ONE_FREE_DELIVERY_UNLOCKED: "One Free Delivery Unlocked",
    ONE_FREE_DELIVERY_SAVINGS: "One Free Delivery savings",
    ONE_SAVINGS: "One Savings",
    COUPON_DISCOUNT_SAVINGS: "Coupon Discount Savings",
    COUPON_CODE_CART: "Coupon Code",
    TOTAL_POTENTIAL_SAVINGS: "Total Potential Savings",
    IS_GUEST_USER: "Is Guest User",
    IS_BOLT_CART: "Is Bolt Cart",
    BOLT_SLA: "Bolt SLA",
    IRCTC_CART_VISIT: "IRCTC Cart Visit",
};
